import TxRecords from '@/services/apis/history/TxRecords'
import React, { memo, useEffect, useState } from 'react'
import { PageModel } from '@/services/apis/BaseModel'
import { ExportItemModel } from '@/services/apis/history/model'
import { Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { useTranslation } from '@/services/i18n'
import { formatTime2, formatTime } from '@/utils/format'

import styles from './index.module.scss'
import { ExportStateEnum, ExportStateMap } from '@/constants/enum'
import { CloudDownloadOutlined } from '@ant-design/icons'

const ExportHistory = memo(() => {
  const { t } = useTranslation()
  const [list, setList] = useState<PageModel<ExportItemModel>>()
  async function getList(page = 1) {
    const res = await TxRecords.getExportList({
      pageNumber: page,
    })
    if (res.success) {
      setList(res.data as any)
    }
  }

  async function download(id: string) {
    const res = await TxRecords.getExportUrl(id)

    if (res.success) {
      window.location.href = res.data as string
    }
  }
  function getStateColor(state: ExportStateEnum) {
    if (state === ExportStateEnum.FAILED) {
      return '#E64646'
    }
    if (state === ExportStateEnum.PROCESSING) {
      return '#12B89A'
    }
    return ''
  }
  function handleChangePage(page: number) {
    getList(page)
  }
  const coloumn: ColumnsType<ExportItemModel> = [
    {
      title: t('record.task'),
      width: 300,
      render: (_: any, record: ExportItemModel) => {
        return (
          <div className={styles.taskContainer}>
            <div className="left">
              {`${record?.workspaceName} ${formatTime2(record?.startTime)}-${formatTime2(
                record.endTime
              )}`}
            </div>
            {record.taskStatus === ExportStateEnum.COMPLETED && (
              <CloudDownloadOutlined
                onClick={() => {
                  download(record.id)
                }}
                style={{ cursor: 'pointer', color: '#12b89a' }}
              />
            )}
          </div>
        )
      },
    },
    {
      title: t('record.state'),

      render(value: any, record: ExportItemModel) {
        return (
          <div
            style={{
              color: getStateColor(record.taskStatus),
            }}
          >
            {ExportStateMap[record.taskStatus]}
          </div>
        )
      },
    },
    {
      title: t('record.createUser'),

      dataIndex: 'createdByName',
    },
    {
      title: t('record.time'),
      render(value, record) {
        return <div>{formatTime(record.createTime)}</div>
      },
    },
  ]
  useEffect(() => {
    getList()
  }, [])

  return (
    <div className={styles.container}>
      <Table
        dataSource={list?.content}
        rowKey={record => record.id}
        columns={coloumn}
        pagination={{
          total: list?.totalElements,
          pageSize: list?.pageSize,
          current: list?.pageNumber,
          onChange: handleChangePage,
        }}
      />
    </div>
  )
})

export default ExportHistory
